module.exports = __webpack_public_path__ + "static/img/pc3.344f753.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/pc3.png
// module id = KNJ+
// module chunks = 1